import React from 'react';
import { XCircle } from 'lucide-react';
const pains = ['Ganas menos de $3.000 usd y no te alcanza para la vida que deseas y mereces vivir', 'Queres trabajar remoto y no sabes por dónde empezar', 'Sentís que Improvisas', 'El algoritmo "te odia"', 'Te da vergüenza grabarte', 'Estás atrapada en una rutina que no te llena y no sabes cómo salir de ahí...'];
export function IntroSection() {
  return <section className="px-6 py-16 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-176">
      <h2 className="font-serif text-4xl md:text-6xl text-brand-navy font-light mb-12 tracking-tight" data-id="element-177">
        ¿Te identificas?
      </h2>

      <ul className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16 max-w-5xl" data-id="element-178">
        {pains.map((item, i) => <li key={i} className="flex items-start gap-4 justify-center px-4 py-3 bg-white/40 backdrop-blur-sm rounded-2xl border border-white/50 shadow-sm md:justify-start transition-all hover:bg-white/60" data-id="element-179">
            <XCircle className="text-[#D98BAF] shrink-0 mt-0.5" size={24} strokeWidth={2} data-id="element-180" />
            <span className="font-medium text-brand-navy/80 text-[16px] leading-relaxed max-w-[280px] text-left" data-id="element-181">
              {item}
            </span>
          </li>)}
      </ul>

      <div className="flex flex-col items-center mb-12" data-id="element-182">
        <p className="font-serif italic font-bold text-2xl md:text-4xl text-brand-navy mb-4" data-id="element-183">
          Yo también estuve ahí... 💔
        </p>
        <p className="text-brand-navy/70 font-medium leading-relaxed md:text-xl max-w-2xl" data-id="element-184">
          Trabajaba en una oficina de 9 a 18 hs incluidos feriados 💔
        </p>
      </div>

      {/* Mirror Selfie */}
      <div className="w-full max-w-md relative mb-16 mt-4" data-id="element-185">
        <div className="absolute -inset-4 bg-gradient-to-tr from-brand-cream via-white to-[#D98BAF]/20 rounded-[3rem] shadow-[0_20px_40px_-15px_rgba(217,139,175,0.3)] transform -rotate-2 border border-white/60" data-id="element-186"></div>
        <img src="https://cdn.magicpatterns.com/uploads/f6Gtv3SeReAZTr37breShA/pasted-image.png" alt="Brenda creadora UGC" className="w-full h-auto rounded-[2.5rem] relative z-10 object-cover aspect-[3/4] shadow-md border border-white/40" data-id="element-187" />
        <div className="absolute -bottom-6 -right-4 text-5xl z-20 animate-bounce drop-shadow-lg" data-id="element-188">
          ✨
        </div>
      </div>

      <p className="text-brand-navy font-medium text-xl md:text-3xl leading-relaxed px-4 max-w-4xl" data-id="element-189">
        Pero eso cambió. Cuando aprendí a Crear Contenido UGC, empecé a{' '}
        <strong className="font-black text-transparent bg-clip-text bg-gradient-to-r from-[#D98BAF] to-brand-pinkDark drop-shadow-sm" data-id="element-190">
          FACTURAR EN GRANDE
        </strong>{' '}
        y cambiar mi vida por completo!
      </p>
    </section>;
}